// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WvxB","top":"styles_top__3l4Ip","left":"styles_left__1Tj47","description":"styles_description__3cyAy"};